import useDragPos from "@/hooks/useDragPos";

// Wrapper trascinabile per pulsanti/pillole flottanti (sopprime il click dopo un drag)
export default function DragWrap({ dragKey, className, children }) {
  const d = useDragPos(dragKey, { filter: false });
  return (
    <div
      ref={d.ref}
      style={{ ...d.style, touchAction: "none" }}
      className={className}
      onPointerDown={d.start}
      onClickCapture={(e) => {
        if (d.consumeMoved()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      data-testid={`drag-${dragKey}`}
    >
      {children}
    </div>
  );
}
